(function(angular, schoolwork12) {

	'use strict';

	angular.module(schoolwork12.app.header.name)
        .controller(schoolwork12.app.header.controllers.headerController,
					[
							'$scope',
							'$http',
							'$log',
							'$q',
							schoolwork12.app.auth.services.authentication,
							function($scope, $http, $log, $q, authentication) {
								$scope.tvschoolurl = "";
								$scope.tvenrollmenturl = "";
								$scope.pfurl ="";
								if (authentication.isAuthenticated()) {
									$scope.loginUserName = authentication
											.getCurrentUser().username;
									$scope.loginUserRole = authentication
											.getPrimaryRole();
								} else {
									$scope.loginUserName = 'N/A';
									$scope.loginUserRole = 'N/A';
								}
								var getKeyCodes = function() {

									getKeyCode()
											.then(
													function(response) {
														$scope.keycode = response.data._keycode;
														$scope.pfurl = schoolwork12.app.pfEndPoint
														.concat(
																'?keyCode=')
														.concat(
																$scope.keycode);
														$scope.tvschoolurl = schoolwork12.app.tvSchoolEndPoint
																.concat(
																		'/wa/k12KeycodeLogin?keyCode=')
																.concat(
																		$scope.keycode);
														$scope.tvenrollmenturl = schoolwork12.app.tvEnrollmentEndPoint
																.concat(
																		'/wa/k12KeycodeLogin?keyCode=')
																.concat(
																		$scope.keycode);
													});
								};

								getKeyCodes();

								function getKeyCode() {

									var request = {
										method : 'POST',
										url : schoolwork12.app.header.endpoints.refreshKeycodeEndpoint,
										headers : {
											'Content-Type' : 'application/json',
											'X-API-TOKEN' : authentication
													.getCurrentUser().keycode,
										}
									};
									return sendRequest(request);
								}

								function sendRequest(config) {

									var deferred = $q.defer();
									$http(config).then(function(response) {
										deferred.resolve(response);
									}, function(error) {
										deferred.reject(error);
									});

									return deferred.promise;
								}
							} ]);

}(angular, schoolwork12));
